module.exports = __webpack_public_path__ + "img/logo_bumn.d724b178.png";